/**
 * Serializes request params into a query string, including the leading "?".
 * Undefined values are dropped; array values repeat the key.
 */
export function buildQueryString(params: Record<string, unknown> = {}): string {
  const q = new URLSearchParams();

  Object.entries(params).forEach(([key, val]) => {
    if (val === undefined) return;
    if (Array.isArray(val)) {
      val.forEach(item => q.append(key, String(item)));
    } else {
      q.set(key, String(val));
    }
  });

  const result = q.toString();
  return result ? `?${result}` : "";
}
